<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>

<app-pesquisar-matricula
  *ngIf="matricula == null"
  [titulo]="'SIOPE'"
  [inputText]="true"
  (colaboradorEmitter)="matriculaListener($event)"
></app-pesquisar-matricula>

<section class="container" *ngIf="matricula != null">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title font-weight-semibold">
        <i
          class="fa fa-arrow-left pr-3 btn"
          aria-hidden="true"
          (click)="retornarTelaInicial()"
          style="cursor: pointer; bottom: 2px"
        ></i>
        SIOPE - Sistema de Informações sobre Orçamentos Públicos em Educação
      </h3>
    </div>

    <div class="card-body">
      <form #colaborador="ngForm" [formGroup]="formColaborador">
        <div class="row mb-4">
          <div class="col-md-2 form-group">
            <label class="font-weight-semibold">Matrícula</label>
            <input
              type="text"
              class="form-control"
              placeholder="Matrícula"
              mask="0*"
              formControlName="matricula"
            />
            <span class="form-text" *ngIf="loading">
              Carregando <i class="fa fa-spinner fa-spin" aria-hidden="false"></i>
            </span>
          </div>

          <div class="col-md-10 form-group">
            <label class="font-weight-semibold">Nome do Colaborador</label>
            <input type="text" class="form-control" placeholder="Nome" formControlName="nome" />
          </div>
        </div>
      </form>
    </div>
  </div>
  <form #cadastro="ngForm" [formGroup]="formCadastro">
    <div class="card shadow-sm">
      <div class="card-body">
        <div class="row">
          <!-- Tipo Categoria -->
          <div class="col-md-6 form-group">
            <label class="font-weight-semibold">Tipo Categoria</label>
            <select
              class="form-control"
              [class.is-invalid]="formCadastro.get('tipoCategoria').invalid && (formCadastro.get('tipoCategoria').touched || formCadastro.get('tipoCategoria').dirty)"
              formControlName="tipoCategoria"
              (change)="onTipoCategoriaChange()"
            >
              <option value="" disabled>Selecione...</option>
              <option *ngFor="let tipo of listaTipoCategoria" [value]="tipo.Id">
                {{ tipo.Descricao }}
              </option>
            </select>
            <div class="invalid-feedback" 
                 *ngIf="formCadastro.get('tipoCategoria').invalid && (formCadastro.get('tipoCategoria').touched || formCadastro.get('tipoCategoria').dirty)">
              Campo Obrigatório
            </div>
          </div>
  
          <!-- Categoria -->
          <div class="col-md-6 form-group">
            <label class="font-weight-semibold">Categoria</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                [class.is-invalid]="formCadastro.get('categoria').invalid && (formCadastro.get('categoria').touched || formCadastro.get('categoria').dirty)"
                [value]="categoriaSelecionada?.Descricao || ''"
                placeholder="Selecione..."
                readonly
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  data-toggle="modal"
                  data-target="#modalCategoria"
                  [disabled]="!formCadastro.get('tipoCategoria')?.value"
                >
                  Selecionar
                </button>
              </div>
            </div>
            <div class="invalid-feedback" 
                 *ngIf="formCadastro.get('categoria').invalid && (formCadastro.get('categoria').touched || formCadastro.get('categoria').dirty)">
              Campo Obrigatório
            </div>
          </div>
  
          <!-- Seguimento -->
          <div class="col-md-4 form-group">
            <label class="font-weight-semibold">Seguimento</label>
            <select 
              class="form-control"
              [class.is-invalid]="formCadastro.get('seguimento').invalid && (formCadastro.get('seguimento').touched || formCadastro.get('seguimento').dirty)"
              formControlName="seguimento"
            >
              <option value="" disabled>Selecione...</option>
              <option *ngFor="let seguimento of listaSeguimentos" [value]="seguimento.Id">
                {{ seguimento.Descricao }}
              </option>
            </select>
            <div class="invalid-feedback" 
                 *ngIf="formCadastro.get('seguimento').invalid && (formCadastro.get('seguimento').touched || formCadastro.get('seguimento').dirty)">
              Campo Obrigatório
            </div>
          </div>
  
          <!-- Vinculo -->
          <div class="col-md-4 form-group">
            <label class="font-weight-semibold">Vinculo</label>
            <select 
              class="form-control"
              [class.is-invalid]="formCadastro.get('vinculo').invalid && (formCadastro.get('vinculo').touched || formCadastro.get('vinculo').dirty)"
              formControlName="vinculo"
            >
              <option value="" disabled>Selecione...</option>
              <option *ngFor="let vinculo of listaVinculos" [value]="vinculo.Id">
                {{ vinculo.Descricao }}
              </option>
            </select>
            <div class="invalid-feedback" 
                 *ngIf="formCadastro.get('vinculo').invalid && (formCadastro.get('vinculo').touched || formCadastro.get('vinculo').dirty)">
              Campo Obrigatório
            </div>
          </div>
  
          <!-- Localização -->
          <div class="col-md-4 form-group">
            <label class="font-weight-semibold">Localização</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                [class.is-invalid]="formCadastro.get('localizacao').invalid && (formCadastro.get('localizacao').touched || formCadastro.get('localizacao').dirty)"
                [value]="localizacaoSelecionada?.Descricao || ''"
                placeholder="Selecione..."
                readonly
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  data-toggle="modal"
                  data-target="#modalLocalizacao"
                  (click)="filtrarLocalizacoes()"
                >
                  Selecionar
                </button>
              </div>
            </div>
            <div class="invalid-feedback" 
                 *ngIf="formCadastro.get('localizacao').invalid && (formCadastro.get('localizacao').touched || formCadastro.get('localizacao').dirty)">
              Campo Obrigatório
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>


</section>

<!-- Card para exibir as qualificações do colaborador -->
<div class="card mt-4" *ngIf="matricula">
  <div class="card-header bg-primary text-white">
    <h4 class="mb-0">Qualificações</h4>
  </div>
  <div class="card-body">
    <div class="row" [formGroup]="qualificacoesForm">
      <div class="col-12">
        <h5 class="font-weight-bold mb-3">{{ this.tipoQualificacao1Descricao }}</h5>
        <div *ngFor="let qualificacao of qualificacoesFUNDEB1" class="mb-4">
          <div class="form-group">
            <label class="d-block mb-2">{{ qualificacao.Descricao }}</label>

            <!-- Campo para "Outros" -->
            <div *ngIf="qualificacao.Outros === 'S'">
              <div class="btn-group" role="group">
                <button type="button" 
                        class="btn btn-outline-primary" 
                        [class.active]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === true"
                        (click)="selecionarResposta(qualificacao.Id, true, 1)">
                  Sim
                </button>
                <button type="button" 
                        class="btn btn-outline-primary" 
                        [class.active]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === false"
                        (click)="selecionarResposta(qualificacao.Id, false, 1)">
                  Não
                </button>
              </div>
            
              <textarea
                class="form-control mt-2"
                [class.is-invalid]="qualificacoesForm.get('qualificacao_' + qualificacao.Id + '_outros')?.invalid && qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === true"
                rows="3"
                [formControlName]="'qualificacao_' + qualificacao.Id + '_outros'"
                placeholder="Especifique..."
                [disabled]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value !== true"
              ></textarea>
              <div class="invalid-feedback" 
                   *ngIf="qualificacoesForm.get('qualificacao_' + qualificacao.Id + '_outros')?.invalid && qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === true">
                Campo obrigatório quando.
              </div>
            </div>

            <div *ngIf="qualificacao.Outros === 'N'" class="btn-group" role="group">
              <button type="button" 
                      class="btn btn-outline-primary" 
                      [class.active]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === true"
                      (click)="selecionarResposta(qualificacao.Id, true, 1)">
                Sim
              </button>
              <button type="button" 
                      class="btn btn-outline-primary" 
                      [class.active]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === false"
                      (click)="selecionarResposta(qualificacao.Id, false, 1)">
                Não
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mt-4">
        <h5 class="font-weight-bold mb-3">{{ this.tipoQualificacao2Descricao }}</h5>
        <div *ngFor="let qualificacao of qualificacoesFUNDEB2" class="mb-4">
          <div class="form-group">
            <label class="d-block mb-2">{{ qualificacao.Descricao }}</label>

            <div *ngIf="qualificacao.Outros === 'S'">
              <div class="btn-group" role="group">
                <button type="button" 
                        class="btn btn-outline-primary" 
                        [class.active]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === true"
                        (click)="selecionarResposta(qualificacao.Id, true, 2)">
                  Sim
                </button>
                <button type="button" 
                        class="btn btn-outline-primary" 
                        [class.active]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === false"
                        (click)="selecionarResposta(qualificacao.Id, false, 2)">
                  Não
                </button>
              </div>
            
              <textarea
                class="form-control mt-2"
                [class.is-invalid]="qualificacoesForm.get('qualificacao_' + qualificacao.Id + '_outros')?.invalid && qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === true"
                rows="3"
                [formControlName]="'qualificacao_' + qualificacao.Id + '_outros'"
                placeholder="Especifique..."
                [disabled]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value !== true"
              ></textarea>
              <div class="invalid-feedback" 
                   *ngIf="qualificacoesForm.get('qualificacao_' + qualificacao.Id + '_outros')?.invalid && qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === true">
                Campo obrigatório quando.
              </div>
            </div>

            <div *ngIf="qualificacao.Outros === 'N'" class="btn-group" role="group">
              <button type="button" 
                      class="btn btn-outline-primary" 
                      [class.active]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === true"
                      (click)="selecionarResposta(qualificacao.Id, true, 2)">
                Sim
              </button>
              <button type="button" 
                      class="btn btn-outline-primary" 
                      [class.active]="qualificacoesForm.get('qualificacao_' + qualificacao.Id)?.value === false"
                      (click)="selecionarResposta(qualificacao.Id, false, 2)">
                Não
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="matricula">
    <div class="card-footer text-right">
      <button type="button" class="btn btn-primary" (click)="onSubmit()">
        <i class="fa fa-save mr-2"></i>Enviar
      </button>
    </div>
  </div>
</div>


<!-- Modal para seleção de categoria -->
<div
  class="modal fade"
  id="modalCategoria"
  tabindex="-1"
  aria-labelledby="modalCategoriaLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalCategoriaLabel">Selecionar Categoria</h5>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Pesquisar categoria..."
            [(ngModel)]="filtroCategoria"
            (input)="filtrarCategorias()"
          />
        </div>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Descrição</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cat of categoriasFiltradas">
                <td>{{ cat.Id }}</td>
                <td>{{ cat.Descricao }}</td>
                <td>
                  <button
                    class="btn btn-sm btn-primary"
                    (click)="selecionarCategoria(cat)"
                    data-dismiss="modal"
                  >
                    Selecionar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
          Fechar
        </button> -->
      </div>
    </div>
  </div>
</div>

<!-- Modal para seleção de localização -->
<div
  class="modal fade"
  id="modalLocalizacao"
  tabindex="-1"
  aria-labelledby="modalLocalizacaoLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalLocalizacaoLabel">Selecionar Localização</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Pesquisar localização..."
            [(ngModel)]="filtroLocalizacao"
            (input)="filtrarLocalizacoes()"
          />
        </div>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Descrição</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loc of localizacoesFiltradas">
                <td>{{ loc.Id }}</td>
                <td>{{ loc.Descricao }}</td>
                <td>
                  <button
                    class="btn btn-sm btn-primary"
                    (click)="selecionarLocalizacao(loc)"
                    data-dismiss="modal"
                  >
                    Selecionar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
